module.exports = __webpack_public_path__ + "img/wap_slides_bg_01.631921ef.png";